module.exports = __webpack_public_path__ + "static/1341570412.c96097c4.jpg";